<template>
  <div class="arouse-wrapper" @click="arouseclose">
    <img src="../../../static/images/arouse.png">
  </div>
</template>
<script>

  export default {
    methods: {
      arouseclose () {
        this.$emit('arouse', false)
      }
    }
  }
</script>
<style lang="less" scoped>
  .arouse-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/arouse/index.vue